import { render, staticRenderFns } from "./column_manuscript.vue?vue&type=template&id=19611f4d&scoped=true&"
import script from "./column_manuscript.vue?vue&type=script&lang=js&"
export * from "./column_manuscript.vue?vue&type=script&lang=js&"
import style0 from "./column_manuscript.vue?vue&type=style&index=0&id=19611f4d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19611f4d",
  null
  
)

export default component.exports